import React from "react"
import PropTypes from "prop-types"

import ComponentErrorMessage from "./ComponentErrorMessage"

import classnames from "classnames"
import textStyleSheet from "ui-Text/styles"

const styleSheet = theme => {
  const textStyles = textStyleSheet(theme)

  return {
    root: {
      ...textStyles.base,
      flex: [0, 0, "auto"],
      overflow: "hidden",
      height: 0,
      transition: theme.transitions.create("height", {
        duration: theme.transitions.duration.shorter,
      }),
    },

    container: {
      backgroundColor: theme.palette.grey[300],
      boxShadow: ["inset", 0, -3, 2, -2, theme.palette.divider],
    },

    content: {},

    in: {
      height: "auto",
    },

    gutterTop: {
      "&$in": {
        marginTop: theme.spacing.unit * 3,
      },
    },

    gutterBottom: {
      "&$in": {
        marginBottom: theme.spacing.unit * 3,
      },
    },

    "color-error": {
      color: theme.palette.error.A400,
    },
  }
}

class ComponentError extends React.Component {
  static propTypes = {
    color: PropTypes.oneOf(["default", "error"]),
    containerClassName: PropTypes.string,
    errors: PropTypes.arrayOf(
      PropTypes.shape({
        message: PropTypes.string,
      })
    ),
    gutterBottom: PropTypes.bool,
    gutterTop: PropTypes.bool,
    in: PropTypes.bool,
    message: PropTypes.string,
    scrolled: PropTypes.bool,
  }

  state = {}

  // eslint-disable-next-line  camelcase
  UNSAFE_componentWillUpdate({ in: inProp }) {
    if (inProp) {
      this._show()
    } else {
      this._hide()
    }
  }

  _captureRoot = c => {
    this._root = c
    if (c && this.props.in) {
      this._show()
    }
  }

  _show() {
    this._root.style.height = `${this._root.scrollHeight}px`
    // If one of the children's props change resulting in a new height try to
    // pick that up and recalculate the desired height.
    setTimeout(() => {
      // If the component is unmounted during the timeout then there's nothing to
      // measure.
      if (!this._root) {
        return
      }
      this._root.style.height = `${this._root.scrollHeight}px`
    })
  }

  _hide() {
    this._root.style.height = "0"
  }

  _renderMessage({ message, errors }) {
    if (message) {
      return <ComponentErrorMessage>{message}</ComponentErrorMessage>
    }

    if (errors) {
      return errors.map(e => <ComponentErrorMessage key={e}>{e.message}</ComponentErrorMessage>)
    }

    return undefined
  }

  render() {
    const {
      children,
      className: classNameProp,
      classes,
      color,
      containerClassName: containerClassNameProp,
      errors,
      gutterTop,
      gutterBottom,
      in: inProp,
      message,
      scrolled, // Ignored, sent if embedded in a ScrollFrame

      ...otherProps
    } = this.props

    const className = classnames(
      classes.root,
      color && classes[`color-${color}`],
      {
        [classes.in]: inProp,
        [classes.gutterTop]: gutterTop,
        [classes.gutterBottom]: gutterBottom,
      },
      classNameProp
    )

    const containerClassName = classnames(classes.container, containerClassNameProp)

    const body = children || this._renderMessage({ message, errors })

    return (
      <div {...otherProps} className={className} ref={this._captureRoot}>
        <div className={containerClassName}>
          <div className={classes.content}>{body}</div>
        </div>
      </div>
    )
  }
}

import withStyles from "@material-ui/core/styles/withStyles"
export default withStyles(styleSheet)(ComponentError)



// WEBPACK FOOTER //
// ../ui-kit/src/components/ui-ComponentError/ComponentError.js